module.exports = __webpack_public_path__ + "static/media/Kotlin.a9aa28c9.png";